import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  FlatList,
  Image,
  StyleSheet,
  ActivityIndicator,
  TouchableOpacity,
} from 'react-native';

const PlanetsScreen = ({ navigation }) => {
  const [planets, setPlanets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPlanets();
  }, []);

  const fetchPlanets = async () => {
    try {
      const response = await fetch('https://dragonball-api.com/api/planets');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      if (data && data.items && Array.isArray(data.items)) {
        setPlanets(data.items);
      } else {
        setError('Invalid data format received from API');
      }
      setLoading(false);
    } catch (err) {
      setError(err.message || 'Error fetching planets');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color="#f4511e" />
      </View>
    );
  }

  if (error) {
    return (
      <View style={styles.centered}>
        <Text style={styles.error}>{error}</Text>
        <TouchableOpacity style={styles.retryButton} onPress={fetchPlanets}>
          <Text style={styles.retryButtonText}>Retry</Text>
        </TouchableOpacity>
      </View>
    );
  }

  const renderPlanetItem = ({ item }) => (
    <TouchableOpacity 
      style={styles.planetCard}
      onPress={() => navigation.navigate('PlanetDetail', { planet: item })}
    >
      <Image
        source={{ uri: item.image || 'https://via.placeholder.com/300x200' }}
        style={styles.planetImage}
        resizeMode="contain"
      />
      <View style={styles.planetInfo}>
        <Text style={styles.planetName}>{item.name || 'Unknown'}</Text>
        <Text style={styles.planetDescription} numberOfLines={2}>
          {item.description || 'No description available'}
        </Text>
      </View>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <FlatList
        data={planets}
        renderItem={renderPlanetItem}
        keyExtractor={(item) => (item.id ? item.id.toString() : Math.random().toString())}
        contentContainerStyle={styles.list}
        ListEmptyComponent={() => (
          <View style={styles.centered}>
            <Text style={styles.error}>No planets found</Text>
          </View>
        )}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  centered: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  list: {
    padding: 10,
  },
  planetCard: {
    backgroundColor: 'white',
    borderRadius: 10,
    overflow: 'hidden',
    marginBottom: 15,
    elevation: 3,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
  },
  planetImage: {
    width: 300,
    height: 300,
    alignSelf: 'center',
    resizeMode: 'contain',
    backgroundColor: '#f0f0f0',
  },
  planetInfo: {
    padding: 15,
  },
  planetName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 8,
  },
  planetDescription: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
  },
  error: {
    color: 'red',
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 10,
  },
  retryButton: {
    backgroundColor: '#f4511e',
    padding: 10,
    borderRadius: 5,
  },
  retryButtonText: {
    color: 'white',
    fontSize: 16,
  },
});

export default PlanetsScreen; 